import React, { useState } from "react";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import "bootstrap-icons/font/bootstrap-icons.css";

const SeoSettings = () => {
  const [formData, setFormData] = useState({
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    canonicalUrl: "",
    ogTitle: "",
    ogDescription: "",
  });

  const [fileList, setFileList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ ...formData, ogImage: fileList[0]?.originFileObj });
  };

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        SEO Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              {[
                { label: "Meta Title", name: "metaTitle" },
                { label: "Meta Keywords", name: "metaKeywords" },
                { label: "Canonical URL", name: "canonicalUrl" },
                { label: "OG Title", name: "ogTitle" },
              ].map((field, i) => (
                <motion.div
                  key={field.name}
                  className="col-md-12"
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.05 }}
                >
                  <label className="form-label">{field.label}</label>
                  <motion.input
                    whileFocus={{ scale: 1.02 }}
                    className="form-control"
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                </motion.div>
              ))}

              {/* TEXTAREAS */}
              {[
                { label: "Meta Description", name: "metaDescription" },
                { label: "OG Description", name: "ogDescription" },
              ].map((field, i) => (
                <motion.div
                  key={field.name}
                  className="col-md-12"
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 + i * 0.05 }}
                >
                  <label className="form-label">{field.label}</label>
                  <motion.textarea
                    whileFocus={{ scale: 1.02 }}
                    className="form-control"
                    rows="3"
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                  />
                </motion.div>
              ))}

              {/* UPLOAD */}
              <motion.div
                className="col-md-12"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                <label className="form-label">OG Image</label>

                <motion.div whileHover={{ scale: 1.01 }}>
                  <Upload
                    beforeUpload={() => false}
                    fileList={fileList}
                    onChange={handleImageChange}
                    accept="image/*"
                    listType="picture"
                  >
                    <Button icon={<UploadOutlined />}>
                      Choose Image
                    </Button>
                  </Upload>
                </motion.div>

                <small className="text-muted">
                  Recommended size 40px × 40px
                </small>
              </motion.div>

            </div>

            {/* BUTTONS */}
            <motion.div
              className="d-flex justify-content-end mt-4 gap-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <motion.button
                type="button"
                whileTap={{ scale: 0.9 }}
                className="btn btn-outline-danger"
              >
                Cancel
              </motion.button>

              <motion.button
                type="submit"
                whileTap={{ scale: 0.9 }}
                className="btn btn-outline-primary"
              >
                Save
              </motion.button>
            </motion.div>
          </form>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SeoSettings;